import React from 'react';

//默认主题
const defaultMainColor = "#4aa5ff";//主色调  中蓝1

const defaultAuxiliaryColor1 = "#ff6468";//辅助色1 中红
const defaultAuxiliaryColor2 = "#2b8ff2";//辅助色3 深蓝
const defaultAuxiliaryColor3 = "#edf6ff";//辅助色2 浅蓝
const defaultAuxiliaryColor4 = "#63b2ff";//辅助色4 中蓝2

const defaultMidtoneColor1 = "#999999";//中色调 深灰
const defaultMidtoneColor2 = "#333333";//中色调 中灰
const defaultMidtoneColor3 = "#dfdfdf";//中色调 浅灰


//细腻主题
const tenderMainColor = "#48cf2f";//主色调  中蓝

const tenderAuxiliaryColor1 = "#ff6468";//辅助色1 中红
const tenderAuxiliaryColor2 = "#28a211";//辅助色3 深蓝
const tenderAuxiliaryColor3 = "#b1dfa8";//辅助色2 浅蓝
const tenderAuxiliaryColor4 = "#84df73";//辅助色4 中蓝2

const tenderMidtoneColor1 = "#999999";//中色调 深灰
const tenderMidtoneColor2 = "#333333";//中色调 中灰
const tenderMidtoneColor3 = "#dfdfdf";//中色调 浅灰


const configJSON = {
    //默认主题
    default: {
        //svg
        svg: {
            width: "1.875rem",//svg的宽度
            height: "1.875rem",//svg的高度
            fill: defaultMainColor,//"#5f5f5f",//svg的颜色
        },
        //按钮
        button: {
            //按钮  按场景类型分类
            scenesType: {
                submit: {//提交类型的按钮 主要按钮
                    cont_color: "#fff",
                    cont_move_color: "#fff",
                    botton_bgcolor: defaultMainColor,//#4aa5ff
                    back_move_bgcolor: "#63b2ff",//
                    back_cli_bgcolor: "#2b8ff2",//
                },
                back: {//返回类型的按钮 次要按钮
                    cont_color: "#000",
                    cont_move_color: "#000",
                    botton_bgcolor: "#FFFFFF",
                    back_move_bgcolor: "#ECEBEB",
                    back_cli_bgcolor: "#b4b3b3"
                },
                delete: {//删除
                    cont_color: "#fff",
                    cont_move_color: "#fff",
                    botton_bgcolor: "#e64340",
                    back_move_bgcolor: "#ff6360",
                    back_cli_bgcolor: "#e4211e"
                },
                disabled: {//禁用
                    cont_color: "#bbbbbb",
                    cont_move_color: "#bbbbbb",
                    botton_bgcolor: "#e3e3e3",
                    back_move_bgcolor: "#e3e3e3",
                    back_cli_bgcolor: "#e3e3e3"
                },
                import: {//导出类型的按钮
                    cont_color: "#fff",
                    cont_move_color: "#fff",
                    botton_bgcolor: "#FF9801",
                    back_move_bgcolor: "#feab31",
                    back_cli_bgcolor: "#e88b02"
                },
            },
            // 默认  按钮类型  不按场景的类型
            buttonType: {
                default: {
                    cont_color: "#000",
                    cont_move_color: "#00BCD4",
                    botton_bgcolor: "#fff",
                    back_move_bgcolor: "#ededed",
                    back_cli_bgcolor: "#ededed",
                },
                first: {
                    cont_color: "#000",
                    cont_move_color: "#fff",
                    botton_bgcolor: "#fff",
                    back_move_bgcolor: "#00BCD4",
                    back_cli_bgcolor: "#00BCD4",
                },
                second: {
                    cont_color: "#fff",
                    cont_move_color: "#fff",
                    botton_bgcolor: "#00BCD4",
                    back_move_bgcolor: "#5ed0df",
                    back_cli_bgcolor: "#5ed0df",
                },
                disabled: {
                    cont_color: "#747474",
                    cont_move_color: "#747474",
                    botton_bgcolor: "#ededed",
                    back_move_bgcolor: "#ededed",
                    back_cli_bgcolor: "#ededed",
                }
            }
        },
        //表单组件
        form: {
            //props.formType  如表单样式长相很多种  default 默认  也可以有横向的
            default_type: {
                publicForm: {
                    border: false,//是否需要边框
                    borderColor: defaultMidtoneColor3,//边框颜色
                    focusBorderColor: defaultMainColor,//鼠标点击的边框颜色
                    disBorder: false,//禁用时 是否需要边框
                    disBorderColor: defaultMidtoneColor3,//禁用时 边框的颜色
                    boxShadow: false,//是否需要边框阴影
                    boxShadowVal: defaultMainColor,//边框阴影的颜色

                    textColor: defaultMidtoneColor2,//描述文字的颜色
                    textAlign: "right",//描述文字的对其方式   left   right
                    disTextColor: "#eee",//禁用时 描述文字的颜色
                    textFontSize: "0.875rem",//描述文字的字体大小

                    dividingLine: false,//是否需要分割的竖线

                    valueBorder: true,//表单值是否需要边框
                    valueBorderColor: defaultMidtoneColor3,//表单值 边框颜色
                    valueFocusBorderColor: defaultMainColor,//表单值 鼠标点击的边框颜色
                    valueColor: "#000",//表单值的字体颜色
                    focusColor: "#000",//鼠标输入文字的颜色 input,textarea
                    disValueColor: defaultMidtoneColor1,//禁用时 表单值的颜色
                    valueFontSize: "0.875rem",//描述文字的字体大小

                    hintColor: defaultMidtoneColor1,//提示文字的颜色
                    disHintColor: defaultMidtoneColor1,//禁用时 提示文字的颜色     还没实现！！！
                    hintFontSize: "0.875rem",//描述文字的字体大小

                    inputSvgFill: defaultMainColor,//下拉按钮的颜色  日期按钮 之类的

                    errorColor: defaultAuxiliaryColor1,
                },
                input: {},
                textarea: {},
                radio: {
                    svgFill: defaultMainColor,//单选按钮 选中的颜色
                    svgFillDis: "#ccc",//单选按钮 未选中的颜色
                },
                checkbox: {
                    svgFill: defaultMainColor,//多选按钮 选中的颜色
                    svgFillDis: "#ccc",//多选按钮 未选中的颜色
                },
                select: {
                    dialogTit: defaultMainColor,//下拉弹出框的标题颜色
                    chooseItem: defaultMainColor,//下拉选中某一栏的颜色
                    moveItem: defaultAuxiliaryColor3,//下拉选中某一栏的颜色
                    selectSize: "0.875rem",//下拉选中值得大小
                },
                selectCheckbox: {
                    svgFill: defaultMainColor,//多选按钮颜色
                    chooseItemBg: defaultAuxiliaryColor3,//已选择在展示区的项item 背景
                    chooseItem: defaultMainColor,//下拉选中某一栏的颜色
                    moveItem: defaultAuxiliaryColor3,//下拉选中某一栏的颜色
                    selectSize: "0.875rem",//下拉选中值得大小
                },
                selectLenovo: {
                    dialogTit: defaultMainColor,//下拉弹出框的标题颜色
                    chooseItem: defaultMainColor,//下拉选中某一栏的颜色
                    moveItem: defaultAuxiliaryColor3,//下拉选中某一栏的颜色
                    selectSize: "0.875rem",//下拉选中值得大小
                },
                selectLenovoCheckbox: {
                    svgFill: defaultMainColor,//多选按钮颜色
                    chooseItemBg: defaultAuxiliaryColor3,//已选择在展示区的项item 背景
                    chooseItem: defaultMainColor,//下拉选中某一栏的颜色
                    moveItem: defaultAuxiliaryColor3,//下拉选中某一栏的颜色
                    selectSize: "0.875rem",//下拉选中值得大小
                },
                date: {
                    handleDayText: defaultMainColor,//选中日期展示区的颜色
                    selectSvg: defaultMainColor,//日期下拉svg的颜色
                    contSvg: "#000",//上个月下个月按钮颜色
                    activeDayBg: defaultMainColor,//点击到那一天的背景颜色
                    moveDayBg: defaultAuxiliaryColor3,//移动到那一天的背景颜色
                    todayBg: defaultAuxiliaryColor3,//今天字体颜色
                    dateHeadBg: defaultMainColor,//日期头部背景颜色
                    moveYear: defaultMainColor,//日期年份和月份下拉移动那一块的颜色
                },
                dateRange: {
                    chooseDateText: defaultMainColor,//选中文字  输入框的颜色
                    bothEndsDay: defaultMainColor,//开始和结束两端的选中日期背景颜色
                    middleDay: defaultAuxiliaryColor3,//开始日期中间段的日期背景色
                    dateHeadBg: defaultMainColor,//日期头部背景颜色
                    moveYear: defaultMainColor,//日期年份和月份下拉移动那一块的颜色
                    contSvg: "#000",//上个月下个月按钮颜色
                },
                dateWeek: {
                    dateHeadBg: defaultMainColor,//日期头部颜色
                    moveYear: defaultMainColor,//日期年份和月份下拉移动那一块的颜色
                    contSvg: "#000",//上个月下个月按钮颜色
                    chooseSvg: defaultMainColor,//选中单行svg的颜色
                    today: defaultMainColor,//今天的日期颜色
                    chooseDayRows: defaultAuxiliaryColor3,//选中的行背景色
                },
                tree: {
                    treeHeadLine: defaultMainColor,//
                    moveTreeItem: defaultAuxiliaryColor3,//选中的行背景色
                }
            },
            box_type: {
                publicForm: {
                    border: true,//是否需要边框
                    borderColor: defaultMidtoneColor3,//边框颜色
                    focusBorderColor: defaultMainColor,//鼠标点击的边框颜色
                    disBorder: true,//禁用时 是否需要边框
                    disBorderColor: defaultMidtoneColor3,//禁用时 边框的颜色
                    boxShadow: true,//是否需要边框阴影
                    boxShadowVal: defaultMainColor,//边框阴影的颜色

                    textColor: defaultMidtoneColor2,//描述文字的颜色
                    textAlign: "left",//描述文字的对其方式   left   right
                    disTextColor: "#eee",//禁用时 描述文字的颜色
                    textFontSize: "0.875rem",//描述文字的字体大小

                    dividingLine: true,//是否需要分割的竖线

                    valueBorder: false,//表单值是否需要边框
                    valueBorderColor: defaultMidtoneColor3,//表单值 边框颜色
                    valueFocusBorderColor: defaultMainColor,//表单值 鼠标点击的边框颜色
                    valueColor: "#000",//表单值的字体颜色
                    focusColor: "#000",//鼠标输入文字的颜色 input,textarea
                    disValueColor: defaultMidtoneColor1,//禁用时 表单值的颜色
                    valueFontSize: "0.875rem",//描述文字的字体大小

                    hintColor: defaultMidtoneColor1,//提示文字的颜色
                    disHintColor: defaultMidtoneColor1,//禁用时 提示文字的颜色     还没实现！！！
                    hintFontSize: "0.875rem",//描述文字的字体大小

                    inputSvgFill: defaultMainColor,//下拉按钮的颜色  日期按钮 之类的

                    errorColor: defaultAuxiliaryColor1,
                },
                input: {},
                textarea: {},
                radio: {
                    svgFill: defaultMainColor,//单选按钮 选中的颜色
                    svgFillDis: "#ccc",//单选按钮 未选中的颜色
                },
                checkbox: {
                    svgFill: defaultMainColor,//多选按钮 选中的颜色
                    svgFillDis: "#ccc",//多选按钮 未选中的颜色
                },
                select: {
                    dialogTit: defaultMainColor,//下拉弹出框的标题颜色
                    chooseItem: defaultMainColor,//下拉选中某一栏的颜色
                    moveItem: defaultAuxiliaryColor3,//下拉选中某一栏的颜色
                    selectSize: "0.875rem",//下拉选中值得大小
                },
                selectCheckbox: {
                    svgFill: defaultMainColor,//多选按钮颜色
                    chooseItemBg: defaultAuxiliaryColor3,//已选择在展示区的项item 背景
                    chooseItem: defaultMainColor,//下拉选中某一栏的颜色
                    moveItem: defaultAuxiliaryColor3,//下拉选中某一栏的颜色
                    selectSize: "0.875rem",//下拉选中值得大小
                },
                selectLenovo: {
                    dialogTit: defaultMainColor,//下拉弹出框的标题颜色
                    chooseItem: defaultMainColor,//下拉选中某一栏的颜色
                    moveItem: defaultAuxiliaryColor3,//下拉选中某一栏的颜色
                    selectSize: "0.875rem",//下拉选中值得大小
                },
                selectLenovoCheckbox: {
                    svgFill: defaultMainColor,//多选按钮颜色
                    chooseItemBg: defaultAuxiliaryColor3,//已选择在展示区的项item 背景
                    chooseItem: defaultMainColor,//下拉选中某一栏的颜色
                    moveItem: defaultAuxiliaryColor3,//下拉选中某一栏的颜色
                    selectSize: "0.875rem",//下拉选中值得大小
                },
                date: {
                    handleDayText: defaultMainColor,//选中日期展示区的颜色
                    selectSvg: defaultMainColor,//日期下拉svg的颜色
                    contSvg: "#000",//上个月下个月按钮颜色
                    activeDayBg: defaultMainColor,//点击到那一天的背景颜色
                    moveDayBg: defaultAuxiliaryColor3,//移动到那一天的背景颜色
                    todayBg: defaultAuxiliaryColor3,//今天字体颜色
                    dateHeadBg: defaultMainColor,//日期头部背景颜色
                    moveYear: defaultMainColor,//日期年份和月份下拉移动那一块的颜色
                },
                dateRange: {
                    chooseDateText: defaultMainColor,//选中文字  输入框的颜色
                    bothEndsDay: defaultMainColor,//开始和结束两端的选中日期背景颜色
                    middleDay: defaultAuxiliaryColor3,//开始日期中间段的日期背景色
                    dateHeadBg: defaultMainColor,//日期头部背景颜色
                    moveYear: defaultMainColor,//日期年份和月份下拉移动那一块的颜色
                    contSvg: "#000",//上个月下个月按钮颜色
                },
                dateWeek: {
                    dateHeadBg: defaultMainColor,//日期头部颜色
                    moveYear: defaultMainColor,//日期年份和月份下拉移动那一块的颜色
                    contSvg: "#000",//上个月下个月按钮颜色
                    chooseSvg: defaultMainColor,//选中单行svg的颜色
                    today: defaultMainColor,//今天的日期颜色
                    chooseDayRows: defaultAuxiliaryColor3,//选中的行背景色
                },
                tree: {}
            },
        },
        //人员选择
        personnel: {
            checkboxOn: "#00bcd4",//列表选择人员的checkbox
            checkboxUp: "#00bcd4",
        },
        //分页
        page: {
            currentNumBg: defaultMainColor,//选中的分页的背景色
            currentNum: "#fff",//选中的分页的字体颜色
            pagebtnBg: "#e2f9fc",//上下页按钮的背景色
            pagebtn: "#00bcd4",//上下页按钮的字体颜色
            jumpBg: defaultMainColor,//跳转按钮的颜色
        },
        //分页
        grid: {
            currentNumBg: defaultMainColor,//选中的分页的背景色
            currentNum: "#fff",//选中的分页的字体颜色
            pagebtnBg: "#e2f9fc",//上下页按钮的背景色
            pagebtn: "#00bcd4",//上下页按钮的字体颜色
            jumpBg: defaultMainColor,//跳转按钮的颜色
        }

    },

    //温柔，细腻的主题
    tender: {
        //svg
        svg: {
            width: "1.875rem",//svg的宽度
            height: "1.875rem",//svg的高度
            fill: tenderMainColor,//svg的颜色
        },
        //按钮
        button: {
            //按钮  按场景类型分类
            scenesType: {
                submit: {//提交类型的按钮 主要按钮
                    cont_color: "#fff",
                    cont_move_color: "#fff",
                    botton_bgcolor: tenderMainColor,//#4aa5ff
                    back_move_bgcolor: "#63b2ff",//
                    back_cli_bgcolor: "#2b8ff2",//
                },
                back: {//返回类型的按钮 次要按钮
                    cont_color: "#000",
                    cont_move_color: "#000",
                    botton_bgcolor: "#FFFFFF",
                    back_move_bgcolor: "#ECEBEB",
                    back_cli_bgcolor: "#b4b3b3"
                },
                delete: {//删除
                    cont_color: "#fff",
                    cont_move_color: "#fff",
                    botton_bgcolor: "#e64340",
                    back_move_bgcolor: "#ff6360",
                    back_cli_bgcolor: "#e4211e"
                },
                disabled: {//禁用
                    cont_color: "#bbbbbb",
                    cont_move_color: "#bbbbbb",
                    botton_bgcolor: "#e3e3e3",
                    back_move_bgcolor: "#e3e3e3",
                    back_cli_bgcolor: "#e3e3e3"
                },
                import: {//导出类型的按钮
                    cont_color: "#fff",
                    cont_move_color: "#fff",
                    botton_bgcolor: "#FF9801",
                    back_move_bgcolor: "#feab31",
                    back_cli_bgcolor: "#e88b02"
                },
            },
            // 默认  按钮类型  不按场景的类型
            buttonType: {
                default: {
                    cont_color: "#000",
                    cont_move_color: "#00BCD4",
                    botton_bgcolor: "#fff",
                    back_move_bgcolor: "#ededed",
                    back_cli_bgcolor: "#ededed",
                },
                first: {
                    cont_color: "#000",
                    cont_move_color: "#fff",
                    botton_bgcolor: "#fff",
                    back_move_bgcolor: "#00BCD4",
                    back_cli_bgcolor: "#00BCD4",
                },
                second: {
                    cont_color: "#fff",
                    cont_move_color: "#fff",
                    botton_bgcolor: "#00BCD4",
                    back_move_bgcolor: "#5ed0df",
                    back_cli_bgcolor: "#5ed0df",
                },
                disabled: {
                    cont_color: "#747474",
                    cont_move_color: "#747474",
                    botton_bgcolor: "#ededed",
                    back_move_bgcolor: "#ededed",
                    back_cli_bgcolor: "#ededed",
                }
            }
        },
        //表单组件
        form: {
            //props.formType  如表单样式长相很多种  default 默认  也可以有横向的
            default_type: {
                publicForm: {
                    border: false,//是否需要边框
                    borderColor: tenderMidtoneColor3,//边框颜色
                    focusBorderColor: tenderMainColor,//鼠标点击的边框颜色
                    disBorder: false,//禁用时 是否需要边框
                    disBorderColor: tenderMidtoneColor3,//禁用时 边框的颜色
                    boxShadow: false,//是否需要边框阴影
                    boxShadowVal: tenderMainColor,//边框阴影的颜色

                    textColor: tenderMidtoneColor2,//描述文字的颜色
                    textAlign: "right",//描述文字的对其方式   left   right
                    disTextColor: "#eee",//禁用时 描述文字的颜色
                    textFontSize: "0.875rem",//描述文字的字体大小

                    dividingLine: false,//是否需要分割的竖线

                    valueBorder: true,//表单值是否需要边框
                    valueBorderColor: tenderMidtoneColor3,//表单值 边框颜色
                    valueFocusBorderColor: tenderMainColor,//表单值 鼠标点击的边框颜色
                    valueColor: "#000",//表单值的字体颜色
                    focusColor: "#000",//鼠标输入文字的颜色 input,textarea
                    disValueColor: tenderMidtoneColor1,//禁用时 表单值的颜色
                    valueFontSize: "0.875rem",//描述文字的字体大小

                    hintColor: tenderMidtoneColor1,//提示文字的颜色
                    disHintColor: tenderMidtoneColor1,//禁用时 提示文字的颜色     还没实现！！！
                    hintFontSize: "0.875rem",//描述文字的字体大小

                    inputSvgFill: tenderMainColor,//下拉按钮的颜色  日期按钮 之类的

                    errorColor: tenderAuxiliaryColor1,
                },
                input: {},
                textarea: {},
                radio: {
                    svgFill: tenderMainColor,//单选按钮 选中的颜色
                    svgFillDis: "#ccc",//单选按钮 未选中的颜色
                },
                checkbox: {
                    svgFill: tenderMainColor,//多选按钮 选中的颜色
                    svgFillDis: "#ccc",//多选按钮 未选中的颜色
                },
                select: {
                    dialogTit: tenderMainColor,//下拉弹出框的标题颜色
                    chooseItem: tenderMainColor,//下拉选中某一栏的颜色
                    moveItem: tenderAuxiliaryColor3,//下拉选中某一栏的颜色
                    selectSize: "0.875rem",//下拉选中值得大小
                },
                selectCheckbox: {
                    svgFill: tenderMainColor,//多选按钮颜色
                    chooseItemBg: tenderAuxiliaryColor3,//已选择在展示区的项item 背景
                    chooseItem: tenderMainColor,//下拉选中某一栏的颜色
                    moveItem: tenderAuxiliaryColor3,//下拉选中某一栏的颜色
                    selectSize: "0.875rem",//下拉选中值得大小
                },
                selectLenovo: {
                    dialogTit: tenderMainColor,//下拉弹出框的标题颜色
                    chooseItem: tenderMainColor,//下拉选中某一栏的颜色
                    moveItem: tenderAuxiliaryColor3,//下拉选中某一栏的颜色
                    selectSize: "0.875rem",//下拉选中值得大小
                },
                selectLenovoCheckbox: {
                    svgFill: tenderMainColor,//多选按钮颜色
                    chooseItemBg: tenderAuxiliaryColor3,//已选择在展示区的项item 背景
                    chooseItem: tenderMainColor,//下拉选中某一栏的颜色
                    moveItem: tenderAuxiliaryColor3,//下拉选中某一栏的颜色
                    selectSize: "0.875rem",//下拉选中值得大小
                },
                date: {
                    handleDayText: tenderMainColor,//选中日期展示区的颜色
                    selectSvg: tenderMainColor,//日期下拉svg的颜色
                    contSvg: "#000",//上个月下个月按钮颜色
                    activeDayBg: tenderMainColor,//点击到那一天的背景颜色
                    moveDayBg: tenderAuxiliaryColor3,//移动到那一天的背景颜色
                    todayBg: tenderAuxiliaryColor3,//今天字体颜色
                    dateHeadBg: tenderMainColor,//日期头部背景颜色
                    moveYear: tenderMainColor,//日期年份和月份下拉移动那一块的颜色
                },
                dateRange: {
                    chooseDateText: tenderMainColor,//选中文字  输入框的颜色
                    bothEndsDay: tenderMainColor,//开始和结束两端的选中日期背景颜色
                    middleDay: tenderAuxiliaryColor3,//开始日期中间段的日期背景色
                    dateHeadBg: tenderMainColor,//日期头部背景颜色
                    moveYear: tenderMainColor,//日期年份和月份下拉移动那一块的颜色
                    contSvg: "#000",//上个月下个月按钮颜色
                },
                dateWeek: {
                    dateHeadBg: tenderMainColor,//日期头部颜色
                    moveYear: tenderMainColor,//日期年份和月份下拉移动那一块的颜色
                    contSvg: "#000",//上个月下个月按钮颜色
                    chooseSvg: tenderMainColor,//选中单行svg的颜色
                    today: tenderMainColor,//今天的日期颜色
                    chooseDayRows: tenderAuxiliaryColor3,//选中的行背景色
                },
                tree: {
                    treeHeadLine: tenderMainColor,//
                    moveTreeItem: tenderAuxiliaryColor3,//选中的行背景色
                }
            },
            box_type: {
                publicForm: {
                    border: true,//是否需要边框
                    borderColor: tenderMidtoneColor3,//边框颜色
                    focusBorderColor: tenderMainColor,//鼠标点击的边框颜色
                    disBorder: true,//禁用时 是否需要边框
                    disBorderColor: tenderMidtoneColor3,//禁用时 边框的颜色
                    boxShadow: true,//是否需要边框阴影
                    boxShadowVal: tenderMainColor,//边框阴影的颜色

                    textColor: tenderMidtoneColor2,//描述文字的颜色
                    textAlign: "left",//描述文字的对其方式   left   right
                    disTextColor: "#eee",//禁用时 描述文字的颜色
                    textFontSize: "0.875rem",//描述文字的字体大小

                    dividingLine: true,//是否需要分割的竖线

                    valueBorder: false,//表单值是否需要边框
                    valueBorderColor: tenderMidtoneColor3,//表单值 边框颜色
                    valueFocusBorderColor: tenderMainColor,//表单值 鼠标点击的边框颜色
                    valueColor: "#000",//表单值的字体颜色
                    focusColor: "#000",//鼠标输入文字的颜色 input,textarea
                    disValueColor: tenderMidtoneColor1,//禁用时 表单值的颜色
                    valueFontSize: "0.875rem",//描述文字的字体大小

                    hintColor: tenderMidtoneColor1,//提示文字的颜色
                    disHintColor: tenderMidtoneColor1,//禁用时 提示文字的颜色     还没实现！！！
                    hintFontSize: "0.875rem",//描述文字的字体大小

                    inputSvgFill: tenderMainColor,//下拉按钮的颜色  日期按钮 之类的

                    errorColor: tenderAuxiliaryColor1,
                },
                input: {},
                textarea: {},
                radio: {
                    svgFill: tenderMainColor,//单选按钮 选中的颜色
                    svgFillDis: "#ccc",//单选按钮 未选中的颜色
                },
                checkbox: {
                    svgFill: tenderMainColor,//多选按钮 选中的颜色
                    svgFillDis: "#ccc",//多选按钮 未选中的颜色
                },
                select: {
                    dialogTit: tenderMainColor,//下拉弹出框的标题颜色
                    chooseItem: tenderMainColor,//下拉选中某一栏的颜色
                    moveItem: tenderAuxiliaryColor3,//下拉选中某一栏的颜色
                    selectSize: "0.875rem",//下拉选中值得大小
                },
                selectCheckbox: {
                    svgFill: tenderMainColor,//多选按钮颜色
                    chooseItemBg: tenderAuxiliaryColor3,//已选择在展示区的项item 背景
                    chooseItem: tenderMainColor,//下拉选中某一栏的颜色
                    moveItem: tenderAuxiliaryColor3,//下拉选中某一栏的颜色
                    selectSize: "0.875rem",//下拉选中值得大小
                },
                selectLenovo: {
                    dialogTit: tenderMainColor,//下拉弹出框的标题颜色
                    chooseItem: tenderMainColor,//下拉选中某一栏的颜色
                    moveItem: tenderAuxiliaryColor3,//下拉选中某一栏的颜色
                    selectSize: "0.875rem",//下拉选中值得大小
                },
                selectLenovoCheckbox: {
                    svgFill: tenderMainColor,//多选按钮颜色
                    chooseItemBg: tenderAuxiliaryColor3,//已选择在展示区的项item 背景
                    chooseItem: tenderMainColor,//下拉选中某一栏的颜色
                    moveItem: tenderAuxiliaryColor3,//下拉选中某一栏的颜色
                    selectSize: "0.875rem",//下拉选中值得大小
                },
                date: {
                    handleDayText: tenderMainColor,//选中日期展示区的颜色
                    selectSvg: tenderMainColor,//日期下拉svg的颜色
                    contSvg: "#000",//上个月下个月按钮颜色
                    activeDayBg: tenderMainColor,//点击到那一天的背景颜色
                    moveDayBg: tenderAuxiliaryColor3,//移动到那一天的背景颜色
                    todayBg: tenderAuxiliaryColor3,//今天字体颜色
                    dateHeadBg: tenderMainColor,//日期头部背景颜色
                    moveYear: tenderMainColor,//日期年份和月份下拉移动那一块的颜色
                },
                dateRange: {
                    chooseDateText: tenderMainColor,//选中文字  输入框的颜色
                    bothEndsDay: tenderMainColor,//开始和结束两端的选中日期背景颜色
                    middleDay: tenderAuxiliaryColor3,//开始日期中间段的日期背景色
                    dateHeadBg: tenderMainColor,//日期头部背景颜色
                    moveYear: tenderMainColor,//日期年份和月份下拉移动那一块的颜色
                    contSvg: "#000",//上个月下个月按钮颜色
                },
                dateWeek: {
                    dateHeadBg: tenderMainColor,//日期头部颜色
                    moveYear: tenderMainColor,//日期年份和月份下拉移动那一块的颜色
                    contSvg: "#000",//上个月下个月按钮颜色
                    chooseSvg: tenderMainColor,//选中单行svg的颜色
                    today: tenderMainColor,//今天的日期颜色
                    chooseDayRows: tenderAuxiliaryColor3,//选中的行背景色
                },
                tree: {}
            },
        },
        //人员选择
        personnel: {
            checkboxOn: "#00bcd4",//列表选择人员的checkbox
            checkboxUp: "#00bcd4",
        },
        //分页
        page: {
            currentNumBg: tenderMainColor,//选中的分页的背景色
            currentNum: "#fff",//选中的分页的字体颜色
            pagebtnBg: "#e2f9fc",//上下页按钮的背景色
            pagebtn: "#00bcd4",//上下页按钮的字体颜色
            jumpBg: tenderMainColor,//跳转按钮的颜色
        }
    },
};

export {
    configJSON
}